(() => {
  const initSuitLp = (root) => {
    if (!root || root.dataset.suitLpReady === 'true') return;
    root.dataset.suitLpReady = 'true';

    const productsSection = root.querySelector('.suit-products');
    if (!productsSection) return;

    const cards = [...productsSection.querySelectorAll('[data-suit-product-card]')];
    const filters = [...productsSection.querySelectorAll('[data-suit-filter]')];
    const resultCount = productsSection.querySelector('[data-suit-result-count]');

    const applyFilter = (category, shouldScroll = false) => {
      let visibleCount = 0;

      cards.forEach((card) => {
        const isVisible = category === 'all' || card.dataset.category === category;
        card.hidden = !isVisible;
        if (isVisible) visibleCount += 1;
      });

      filters.forEach((button) => {
        const isActive = button.dataset.suitFilter === category;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', String(isActive));
      });

      if (resultCount) resultCount.textContent = String(visibleCount);
      if (shouldScroll) productsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    filters.forEach((button) => {
      button.addEventListener('click', () => applyFilter(button.dataset.suitFilter));
    });

    root.querySelectorAll('[data-suit-jump-filter], [data-suit-filter-trigger]').forEach((trigger) => {
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        const category = trigger.dataset.suitJumpFilter || trigger.dataset.suitFilterTrigger;
        applyFilter(category, true);
      });
    });
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-suit-lp]').forEach(initSuitLp);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();

